import { Button } from 'antd';
import { ReactComponent as InternetIcon } from '../../assets/icons/wifi-icon.svg';
import { ReactComponent as PhoneIcon } from '../../assets/icons/phone-icon.svg';
import { ReactComponent as MobileIcon } from '../../assets/icons/smartphone-icon.svg';
import { ReactComponent as InfoIcon } from '../../assets/icons/info-icon-offer.svg';
import { ReactComponent as ArrowDown } from '../../assets/icons/chevron-down.svg';
import { useLocation } from 'react-router-dom';
import { useState } from 'react';

const OfferCard = props => {
  const [openInfo, setOpenInfo] = useState(false);
  const title = props.offer?.offerName ?? 'Offer';
  const price = props.offer?.amount ?? 0.0;
  const costWithoutSubsidy = props.offer?.costWithoutSubsidy ?? '';
  const subsidizedCost = props.offer?.subsidizedCost ?? '-';
  const description = props.offer?.description ?? '';
  const internet = props.offer?.offerInternet ?? '';
  const landline = props.offer?.offerLandline ?? '';
  const mobile = props.offer?.offerMobile ?? '';
  const info = props.offer?.additionalInfo ?? '';
  const link = props.offer?.link ?? '/';
  const oneOffWithoutSubsidy = props.offer?.oneOffWithoutSubsidy ?? '';
  const oneOffWithSubsidy = props.offer?.oneOffWithSubsidy ?? '';

  const descriptionLines = description?.split("\n") ?? [description];
  // const costWithoutSubsidyLines = costWithoutSubsidy?.split("\n") ?? [costWithoutSubsidy];
  // const subsidizedCostLines = subsidizedCost?.split("\n") ?? [subsidizedCost];
  return (
    <div className="offer-card" key={`${props?.offer?.offerCode ?? '0'}-card`}>
      <div className="card-upper">
      <div className="card-header">
        <div className="offer-title">{title || '-'}</div>
        <div className="offer-2nd-line">
          {price !== 0 && (
            <>
              Από{' '}
              <span className="offer-price">
                {price.toLocaleString('en-US', {
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2,
                }) || '-'}
              </span>
              <span className="offer-price currency">€</span>
            </>
          )}
          {!price && costWithoutSubsidy && (
            <>
              Τιμή προσφοράς χωρίς επιδότηση:
              {/* {costWithoutSubsidyLines.map((line, index) => <p className="offer-price">{line || '-'}</p>)} */}
              <p className="offer-price">{costWithoutSubsidy || '-'}</p>
              Εφάπαξ Κόστος σύνδεσης χωρίς επιδότηση:
              <p className="offer-price">{oneOffWithoutSubsidy || '-'}</p>
            </>
          )}
          {/* <br /> */}
          {!price && subsidizedCost && (
            <>
              Τιμή προσφοράς μετά την επιδότηση:
              {/* {subsidizedCostLines.map((line, index) => <p className="offer-price">{line || '-'}</p>)} */}
              <p className="offer-price">{subsidizedCost || '-'}</p>
              Εφάπαξ Κόστος σύνδεσης μετά την επιδότηση:
              <p className="offer-price">{oneOffWithSubsidy || '-'}</p>
            </>
          )}
        </div>
      </div>
      <div className="card-info">
        {/* {!description && (
          <>
            <div className="info-internet">
              <InternetIcon />
              <span>{internet || '-'}</span>
            </div>
            <div className="info-landline">
              <PhoneIcon />
              <span>{landline || '-'}</span>
            </div>
            <div className="info-mobile">
              <MobileIcon />
              <span>{mobile || '-'}</span>
            </div>
          </>
        )} */}
        {description && (
          <div className="info-internet">
            <div className="miltiple-icons">
              {/* {description?.toLowerCase()?.includes('internet') && ( */}
                <InternetIcon />
              {/* )} */}
              {/* {(description?.toLowerCase()?.includes('σταθερ') ||
                description?.toLowerCase()?.includes('όλους')) && <PhoneIcon />}
              {(description?.toLowerCase()?.includes('κινητ') ||
                description?.toLowerCase()?.includes('όλους')) && <MobileIcon />} */}
            </div>
            <div>{descriptionLines.map((line, index) => <p key={`description-line-${index}`} className='mb-0'>{line || ''}</p>)}</div>
          </div>
        )}
        {<div className={`info-more${openInfo ? ' expanded' : ''}`} style={{visibility: info ? 'visible' : 'hidden'}}>
          <InfoIcon />
          <div className="more-info-line">
            <div
              className="more-info-pseudobutton"
              onClick={() => setOpenInfo(!openInfo)}
            >
              <span>Περισσότερες Πληροφορίες</span>
              <ArrowDown
                className="colored-svg blue"
                onClick={() => setOpenInfo(!openInfo)}
              />
            </div>
            <span className={'more-info-block'}>{info || '-'}</span>
          </div>
        </div>}
      </div>
      </div>
      <div className="card-footer">
      <div className="card-action">
        <Button
          onClick={() => {
            window.open(link, '_blank');
          }}
        >
          Μάθε Περισσότερα
        </Button>
      </div>
      </div>
    </div>
  );
};

export default OfferCard;
